
/**
 * Basic ENUM to track the status' of async tasks
 */
export const ASYNC_STATUS = {
  IDLE: 'a',
  INPROGRESS: 'b',
  COMPLETE: 'c'
};


/**
 * helper function for determining whether async state is still loading. This
 * code assumes we are passed 
 */
export function isLoading(status) {
  return (status != ASYNC_STATUS.COMPLETE);
}

